import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";
import { IMerchantBank } from "./_types";

// Define the request type for updating a merchant bank
// Based on the provided JSON structure and existing IMerchantBank
export interface IMerchantBankUpdateRequest {
  id: number;
  merchantId: number;
  currencyCode: number;
  iban: string;
  bankCode: string;
  accountOwner: string;
  bankType: number; // Assuming bankType is always 1 as per AddMerchantBankModal

  currencyCode1?: number;
  iban1?: string;
  bankCode1?: string;
  accountOwner1?: string;
  bankType1?: number;

  currencyCode2?: number;
  iban2?: string;
  bankCode2?: string;
  accountOwner2?: string;
  bankType2?: number;

  // Include other fields from IMerchantBank that might be sent in an update
  status?: string;
  // systemDate, createDate, etc. are usually handled by the backend
}

type IMerchantBankUpdateResponse = BaseResponse<IMerchantBank>;

async function updateMerchantBank(
  data: IMerchantBankUpdateRequest
): Promise<IMerchantBankUpdateResponse> {
  try {
    const response = await axiosInstance.put("/MerchantBank/Update", data);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useMerchantBankUpdate() {
  return useMutation<IMerchantBankUpdateResponse, Error, IMerchantBankUpdateRequest>(
    updateMerchantBank,
    {
      // Optionally, you can add onSuccess/onError callbacks here
      // or handle them directly where the hook is used.
    }
  );
}
